import postscribe from "postscribe";
function postscribePlugin_default(ctx, inject) {
  inject("postscribe", postscribe);
}
export {
  postscribePlugin_default as default
};
